import { render, staticRenderFns } from "./CreateNotification.vue?vue&type=template&id=97227152&"
import script from "./CreateNotification.vue?vue&type=script&lang=js&"
export * from "./CreateNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports